import { call, put, select, takeEvery } from 'redux-saga/effects';
import { newDealerActionCreators, NewDealerActionKeys } from '..';
import { IState } from '../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { UpdateNewDealerRequest } from '../newDealerActionTypes';
import * as api from '../newDealerApi';
import { INewDealerRequestFull } from '../newDealerInterfaces';
import { getNewDealerRequest } from '../newDealerSelectors';

function* updateNewDealerRequestSaga(action: UpdateNewDealerRequest) {
  yield put(uiActionCreators.showSpinnerDialog());
  const current = yield select((state: IState) => getNewDealerRequest(state, action.payload.newDealerRequestId));

  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestFull>> = yield call(
    api.updateNewDealerRequest,
    {
      ...current,
      ...action.payload
    }
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(newDealerActionCreators.setRequest(response.value.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateNewDealerRequest() {
  yield takeEvery(NewDealerActionKeys.UPDATE_NEW_DEALER_REQUEST, updateNewDealerRequestSaga);
}
